/**
 * Replaces any character that is not a number or a letter (case-insensitive)
 * @param string
 */
export function filterEverythingExceptNumbersAndLetters(string: string) {
  return string.replace(/[^A-Za-z0-9]+/g, '')
}

/**
 * Asserts whether the given URL is valid
 */
export function checkIfUrlIsValid(urlToCheck: string) {
  let isValid = false

  try {
    new URL(urlToCheck)

    const validURLPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '(([a-z\\d](?:[a-z\\d-]*[a-z\\d])?\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(#[-a-z\\d_]*)?$',
      'i',
    )

    isValid = validURLPattern.test(urlToCheck)
  } catch (_e) {
    // catches error, isValid already set to false
  }

  return isValid
}
